import styled from 'styled-components'

export const Footer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.km8};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    font-weight: ${({ theme }) => theme.font.weight.medium};
    color: ${({ theme }) => theme.neutral.text.default};
  }

  button {
    font-size: ${({ theme }) => theme.font.size.m2};
  }
`
